import {
  DialogActions,
  Button,
  Stack,
  Switch,
  FormControlLabel,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { ActionsProps } from "./types";
import { useTranslation } from "../../../../../hooks/useTranslation";

export const Actions = ({
  allowOverShipment,
  onAllowOverShipmentChange,
  onClose,
  onNext,
  isFormValid,
}: ActionsProps) => {
  const { translate, translateWithoutPrefix } = useTranslation(
    "pages.orderDetails.prepareShipment",
  );

  return (
    <DialogActions
      sx={{
        mx: 2,
        my: 1,
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <FormControlLabel
        control={
          <Switch
            checked={allowOverShipment}
            onChange={(e) => onAllowOverShipmentChange(e.target.checked)}
          />
        }
        label={translate("allowOverShipment")}
      />

      <Stack direction="row" spacing={1}>
        <Button onClick={onClose}>
          {translateWithoutPrefix("buttons.cancel")}
        </Button>

        <LoadingButton
          variant="contained"
          onClick={onNext}
          disabled={!isFormValid}
        >
          {translateWithoutPrefix("buttons.next")}
        </LoadingButton>
      </Stack>
    </DialogActions>
  );
};
